export default __webpack_public_path__ + "static/media/ic_motorcycle.36f979ec.svg";